<template>
  <ColumnBarChartTemplate
    :chartMainData="lastActivityMonthDistribution"
    :chartHeight="314"
    :yearStart="2024"
    :chartOptionsFuncParams="chartOptionsFuncParams"
    chartSeriesYKey="numberOrActiveUsers"
    chartTitle="Последняя активность участников платформы"
    @year-update="yearUpdate"  
  />
</template>
<script>
import ColumnBarChartTemplate from "./templates/ColumnBarChartTemplate.vue";
import { graphQueryConstructor } from "@/tools/graphQueryConstructor";
import { gQueryOptionsTemplate } from './chartHelper';
import gql from 'graphql-tag';
import { mapGetters } from 'vuex';

export default {
  name: "LastActivityChart",
  components: {
    ColumnBarChartTemplate,
  },
  props: {
    apolloSearchString: {
      type: String,
      default: "",
    },
    userSearchFilters: {
      type: Object,
    },
    selectedTags: {
      type: Array,
      default: () => [],
    },
  },
  apollo: {
    lastActivityMonthDistribution: {
      query() {
        return gql(graphQueryConstructor(
          ...gQueryOptionsTemplate(
              this.hasUserContactsAccess,
              this.apolloSearchString,
              this.userSearchFilters,
              this.selectedTags,
              "lastActivityMonthDistribution",
              this.year,
            )
        ));
      },
    },
  },
  data() {
    return {
      year: new Date().getFullYear(),
      chartOptionsFuncParams: {
        title: {
          word: "Участни",
          e1: "к",
          e2: "ка",
          e3: "ков",
        },
      },
    };
  },
  methods: {
    yearUpdate(value) {
      this.year = value;
    },
  },
  computed: {
    ...mapGetters('auth', ['hasUserContactsAccess']),
  },
}; 
</script>
<style>
</style>